<template>

  <div class="common-seach-wrap">
    <el-tabs v-model="taskName">
      <el-tab-pane label="任务中心" name="list"></el-tab-pane>
      <el-tab-pane label="任务设置" name="setting"></el-tab-pane>
    </el-tabs>
    <Task v-if="taskName == 'list'"></Task>
    <Setting v-if="taskName == 'setting'"></Setting>
  </div>
</template>
<script>
  import Task from './task/index';
  import Setting from './task/setting';
export default {
  components: {
    Task,
    Setting
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0
      },
      taskName: 'list'
    };
  },
  methods: {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/task/index.vue